import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { BorderColor } from "../../../../Constant";
import { BORDER_COLOR } from "../../../../Data/UiKit/HelperClasses";

export const BorderColors = () => {
  return (
    <Col xl="3" sm="6">
      <div className="border-wrapper h-100 alert-light-light dark-helper">
        <H4 className="mb-3">{BorderColor}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box border-primary border"></div>
          <span>.border-primary</span>
        </div>
        {BORDER_COLOR.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box ${item} border`}></div>
            <span>.{item}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
